<template>
    <ies-form-field :field="field">
        <v-layout row wrap>
            <v-col cols="3">
                <v-btn v-on:click="chooseVan" 
                       v-show="!shouldShowPicker">{{ buttonLabel }}</v-btn>
                <v-btn v-on:click="clearVan" 
                       v-show="selectedVan">Clear</v-btn>
				            </v-col>

	            <v-col cols="10" v-if="shouldShowPicker">
                <v-container>
                    <v-layout row wrap>
 
                        <v-col cols="10">
                            <div>
                            <v-text-field hide-details
                                v-model="vanViewNumber" 
                                v-on:keyup="updateVanNumber()"
								:required="this.field.required" 
                             ></v-text-field> 
                             <span v-if="this.selectedVan != null">provided by <strong>{{ providersById[this.selectedVan.van_provider_key].van_provider_name }}</strong>, value {{ selectedVan.amount ? selectedVan.amount : "N/A" }} GBP <v-btn :href="selectedVan.url">View Card</v-btn></span>
                             </div>

                             <div class="selectable-vans-results" v-if="vanOptions.length && shouldShowVans">
                                 <ul class="selectable-vans-list">
                                     <li v-for="van in vanOptions" 
                                         v-on:click="selectVan(van.van_key)">{{ providersById[van.van_provider_key].van_provider_name }} -
                                                                                {{ van.van_number }} ({{ van.amount ? van.amount : "N/A" }} GBP)</li>
                                 </ul>
                             </div>
                         </v-col>
<!--
                          <v-col cols="12">
                              <v-btn v-on:click="done">Done</v-btn>
                          </v-col>
-->
                   </v-layout>
               </v-container>
           </v-col>

           <input type="hidden" :name="field.fieldName" :value="field.value">
			<v-alert type="error" dismissable value="true" v-if="errorMessages && errorMessages.length">
                <div v-for="(error, index) in errorMessages" :key="index" >{{ error.reason }}*</div>
            </v-alert>
           <!-- <v-alert type="error" :value="field.errors" style="width: 100%" v-if="field.errors">
               <li v-for="error in field.errors">
                   {{ error }}
               </li>
           </v-alert> -->
        </v-layout>
    </ies-form-field>
</template>

<script>
    /**
     * Allows the selection of a virtual credit card ID by choosing its code from
     * a selection downloaded from the API on creation
     *
     * @todo refactor, make more efficient
     */
    export default {
        name: 'ies-vanKey',
        props: ['field', 'configuration', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
				showValidationGuide: false,

				errorMessages: [],

                /** string view model */
                vanViewNumber: '',

                providers: [],

                /** array of van options presented to the user */
                vanOptions: [],

                /** data model of all supported vans */
                vans: [],

                /** view model to determine whether the van picker should display */
                shouldShowPicker: true,

                /** The van chosen by the user */
                viewValue: parseInt(this.field.value),

                selectedVan: null,

                /** For where the component is used in event mode to talk to other components */
                config: {'shouldEmitOnSelect': false, 'selectEventName': ''}
            }
        },
        created:function() {
            // Load the vans list from the server
            this.getProviders();
            this.getVans();

            if (this.configuration){
                var config = JSON.parse(this.configuration);
                console.log(config);
                if (config.shouldEmitOnSelect && config.selectEventName){
                    this.config.shouldEmitOnSelect = config.shouldEmitOnSelect;
                    this.config.selectEventName = config.selectEventName;
                }
            }

            // We may want to move this into the configuration rather than assume all of the instances may need to listen
            this.addEventListeners();
        },

        methods: {

            getProviders:function(){
                axios.get('/api/accounts/van-service-providers')
                .then(function(response){
                    this.providers = response.data;
                }.bind(this));
            },

            setDefaultValueFromUrl: function(){
                // Only try to use the data if it is set, otherwise it will simply crash
                if (this.page && this.page.edit_url){
                    return;
                }

                // Find out if the URL has a van ID in it
                // by checking the edit url pattern for one
                // and making a note of which part it is in
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index){
                    if (bit == '{Van.van_key}'){
                        console.log("found it ", bit, index);
                        foundIndex = index;
                    }
                });

                // If we found a van key in the url pattern
                // then extract the value from the current page
                // url at that part
                var selectedVanKey = null;
                if (foundIndex !== null){
                    var urlBits = location.pathname.split('/').splice(1);
                    console.log(urlBits);
                    console.log("van key from url is ", urlBits[foundIndex]);
                    selectedVanKey = urlBits[foundIndex];

                    // The field value is set to that value by default
                    this.field.value = parseInt(selectedVanKey);
                }
            },

            addEventListeners: function(){
                var self = this;

            	this.$root.$on('Field: set errors', function(payload){
                	console.log("TEXT: I heard ", payload);
                	if (payload.modelName = self.field.modelName && payload.fieldName == self.field.fieldName){
                   		self.errorMessages = payload.errors;
                    	console.log("TEXT: I set ", self.field.errors);
                	}
            	});

			//	updateField: function(){
            //		this.field.value = this.input;
            //		this.errorMessages = [];
            //		this.$root.$emit('Edit: Update Field', {'id': 'notset', 'field': this.field, 'value': this.field.value});
        	//	},

                this.$root.$on('Van Key: set', function(payload){
                    console.log("Have heard ", payload);
                    if (payload.vanKey){
                        self.selectVan(payload.vanKey);
                    }
                    else {
                        self.clearVan();
                    }
                });
            },
			
			toggleValidationGuide: function(){
    	        this.showValidationGuide = !this.showValidationGuide;
	        },

			validationRuleAsString: function(rule){
            	console.log("explain rule");
            	var explainer = '';
           		switch(rule.ruleType){
            	    case 'minLength': explainer = "The text must be at least " + rule.value + " characters long"; break;
        	        case 'maxLength': explainer = "The text must not be more than " + rule.value + " characters long"; break;
    	            case 'minValue': explainer = "The value must be more than " + rule.value; break;
	                case 'maxValue': explainer = "The value must be less than " + rule.value; break;
                	case 'notEmpty': explainer = "The field must not be empty"; break;
                	case 'regExp': explainer = "Pattern: " + rule.value; break;
                	default:
                	    explainer = rule.ruleType + ' ' + rule.value;
            	}
            	console.log(explainer);
            	return explainer;
        	},

            getVans:function(){
                var self = this;
                axios.get('/api/vans')
                .then(function(response){
                    this.vans = response.data;
                    this.vans.forEach(function(van){
                        van.url = "/vans/" + van.van_key;
                        if (van.van_key == self.field.value){
                            self.selectedVan = van;

                            // Set the view models so that it is reflected to the users
                            self.vanViewNumber = van.van_number;
                        }
                    });
                }.bind(this));
            },

            updateVanNumber: function(){
                if (this.vanTypeTimer){
                    clearTimeout(this.vanTypeTimer);
                }
                this.vanTypeTimer = setTimeout(this.refineVanOptions, 333);
           },


            refineVanOptions: function(){
                console.log("REFINE VAN OPTIONS");
                var self = this;
 
                var vanOptions = [];
                this.vans.forEach(function(van){
                    if (van.van_number.toLowerCase().includes(self.vanViewNumber.toLowerCase()) || van.van_number.toLowerCase().includes(self.vanViewNumber.toLowerCase())){
                        vanOptions.push(van);
                    }
                });
                this.vanOptions = vanOptions;


                // If there is only one van left in the list of options then we select it
                if (this.vanOptions.length === 1){
                    this.selectedVan = this.vanOptions[0];
                    this.updateFieldValue();
                }
                this.shouldShowVans = true;
            },

            selectVan: function(vanKey){
                var self = this;
                this.vans.forEach(function(van){
                    if (van.van_key === vanKey){
                        self.selectedVan = van;
                        self.vanViewNumber = van.van_number;
                        self.updateFieldValue();
                    }
                });
                this.shouldShowVans = false;
            },

            chooseVan: function(){
                this.shouldShowPicker = true;
            },

            clearVan: function(){
                this.selectedVan = null;
                this.vanViewNumber = '';
                this.field.value = null;

                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {vanKey: null});
                }
            },

            done: function(){
                this.shouldShowPicker = false;
            },

            updateFieldValue: function(){
                this.field.value = this.selectedVan.van_key;

                console.log("updatefieldvalue on select: ", this.config);
                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {vanKey: this.field.value});
                }
            }
        },
        watch: {
            viewValue: function (newValue) {
            }
        },
        computed: {
            buttonLabel: function(){
                return this.selectedVan ? "(" + this.selectedVan.van_number + ") " + this.selectedVan.amount : "Choose";
            },

            /**
             * Get an array of virtual credit card service providers as an object
             * where its ID number is the key which allows it to be looked up
             * This is used as a lookup for finding the provider for any given
             * VAN by its ID without doing any real work to get it
             */
            providersById: function(){
                var providers = {};
                this.providers.forEach(function(provider){
                    providers[provider.van_provider_key] = provider;
                });
                console.log(providers);
                return providers;
            }
        }

    }
</script>

<style>
.selectable-vans-results{
    background-color: white;
    border: solid 1px #f5f5f5;
    width: auto;
    min-width: 20rem;
    max-height: 10rem;
    overflow-y: auto;
    position: absolute;
    z-index: 1;
}

.selectable-vans-list {
  list-style-type: none;
}

.selectable-vans-list li {
    cursor: pointer;
    padding: 3px;
}

.selectable-vans-list li:hover {
    background-color: #f5f5f5;
}
</style>
